var _excluded = ["children", "icon", "iconAction", "rounded", "size", "square", "variant"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styled, { css } from 'styled-components';
import { Sizes } from "../../../constants.js";
import Icon from "../../basic/Icon/Icon.js";
var Variants = {
  SUCCESS: 'success',
  INFO: 'info',
  NEUTRAL: 'neutral',
  ERROR: 'error',
  WARNING: 'warning'
};
var SquareHeights = {
  [Sizes.SMALL]: '18px',
  [Sizes.MEDIUM]: '30px'
};
var StyledSpan = styled.span.withConfig({
  componentId: "CL__sc-6eljgs-0"
})(["align-items:center;border-radius:var( --border-radius-", " );color:var(--black);display:inline-flex;gap:3px;font:", ";", " background-color:", ";& > span:last-child{display:inline-flex;justify-content:center;align-items:center;}"], _ref => {
  var {
    rounded
  } = _ref;
  return rounded ? 'round' : 'small';
}, _ref2 => {
  var {
    size
  } = _ref2;
  return size === Sizes.SMALL ? 'var(--body-text-x-small)' : 'var(--body-text-small)';
}, _ref3 => {
  var {
    size,
    square
  } = _ref3;
  return square ? css(["align-items:center;aspect-ratio:1;justify-content:center;padding:0;width:", ";"], SquareHeights[size !== null && size !== void 0 ? size : Sizes.SMALL]) : css(["padding:", ";"], size === Sizes.SMALL ? '0 var(--spacing-1)' : 'calc(var(--spacing-1) / 2) var(--spacing-2)');
}, _ref4 => {
  var {
    variant
  } = _ref4;
  if (variant === Variants.ERROR) return 'var(--red-1)';
  if (variant === Variants.INFO) return 'var(--blue-1)';
  if (variant === Variants.SUCCESS) return 'var(--green-1)';
  if (variant === Variants.WARNING) return 'var(--yellow-1)';
  return 'var(--gray-2)';
});
var StyledIconButton = styled.button.withConfig({
  componentId: "CL__sc-6eljgs-1"
})(["color:inherit;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;box-sizing:border-box;background:none;border:none;border-radius:var(--border-radius-round);box-shadow:0 0 0 1px transparent;width:auto;padding:0;margin:0;transition:var(--hover-transition);transition-property:box-shadow,color;appearance:none;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;&::-moz-focus-inner{border:0;padding:0;margin-top:-2px;margin-bottom:-2px;}&:focus-visible{outline:0;color:var(--btn-color-hover);box-shadow:0 0 0 1px var(--btn-color-hover);}&:hover{color:var(--btn-color-hover);box-shadow:0 0 0 1px var(--btn-color-hover);}&:active{color:var(--btn-color-active);box-shadow:0 0 0 1px var(--btn-color-active);}"]);
var BadgeIcon = /*#__PURE__*/React.forwardRef((_ref5, ref) => {
  var {
    icon,
    iconAction,
    size
  } = _ref5;
  if (!icon) return null;
  var innerIcon = /*#__PURE__*/React.createElement(Icon, {
    component: icon,
    size: size === 'small' ? 12 : 18
  });
  if (iconAction) {
    return /*#__PURE__*/React.createElement(StyledIconButton, {
      type: "button",
      role: "button",
      onClick: iconAction,
      ref: ref
    }, innerIcon);
  }
  return /*#__PURE__*/React.createElement("span", {
    ref: ref
  }, innerIcon);
});
var Badge = /*#__PURE__*/React.forwardRef((_ref6, ref) => {
  var {
      children,
      icon,
      iconAction,
      rounded = false,
      size = Sizes.SMALL,
      square = false,
      variant = Variants.NEUTRAL
    } = _ref6,
    props = _objectWithoutProperties(_ref6, _excluded);
  var hasOneLetterAndSquare = square && typeof children === 'string' && children.length === 1;
  return /*#__PURE__*/React.createElement(StyledSpan, _extends({
    ref: ref,
    rounded: rounded,
    size: size,
    square: hasOneLetterAndSquare,
    variant: variant
  }, props), children, icon && /*#__PURE__*/React.createElement(BadgeIcon, {
    icon: icon,
    iconAction: iconAction,
    size: size
  }));
});
export default Badge;